import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Observable } from 'rxjs';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'app-package-editor-ibextablet',
    templateUrl: './package-editor-ibextablet.component.html',
    styleUrls: ['./package-editor-ibextablet.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageEditorIbextabletComponent implements OnInit, OnDestroy {

  public packageId;
  public myPackage: Models.Package;

  public messages;

  @Input() onSave: Observable<any>;
  public submitRequest = false;
  public availableLanguages;
  public generalFieldNames = ['enabled', 'disableWidgetSubtitle', 'fallbackInterval', 'screensaverTimeout', 'translationOverwrites', 'overwritePreviewLink'];
  public styleFieldNames = ['navigation', 'navigationText', 'cardColor', 'cardOpacity', 'cardBlur', 'cardCorners', 'contentText', 'buttonColor', 'buttonOpacity',
    'disableBlurInApp', 'logoPosition', 'customCss'];
  private subscription: any;

  constructor(private route: ActivatedRoute, private snackbar: SnackbarService, private packageService: PackageService, private ts: TranslateService) {
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.route.snapshot.params['id'];
    this.subscription = this.onSave.subscribe(type => {
      if (type === 'ibextablet-reload') {
        this.initPackage();
      } else if (type === 'ibextablet') {
        this.save();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  public async save() {
    await this.packageService.update(this.myPackage._id, this.myPackage);
    this.submitRequest = false;
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  private async initPackage() {
    const myPackage = await this.packageService.get(this.packageId);
    this.myPackage = myPackage;
    this.availableLanguages = myPackage.availableLanguagesCached;

    if (!this.myPackage.ibexTablet) {
      this.myPackage.ibexTablet = new Models.PackageIbexTablet();
    }
  }
}
